import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Segment } from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";
import StepList from "./components/StepList";
import Search from "./components/Steps/Search";
import Prices from "./components/Steps/Prices";
import BasicInfos from "./components/Steps/BasicInfos";
import Attributes from "./components/Steps/Attributes";
import Confirmation from "./components/Steps/Confirmation";
import { findProducts, RESET_SEARCH } from "../../reducer/actions";
import { getProducts } from "../../reducer";
import { push } from "react-router-redux";
import { hasPermission } from "../../../../reducer";

const emptyProduct = {
    code: "",
    code2: "",
    code3: "",
    name: "",
    description: "",
    manufacturerName: "",
    supplier_id: 0,
    country_id: 0,
    brand_id: 0,
    group_id: 0,
    cost: 0,
    priceWithVat: 0,
    price_lists: [],
    variations: [],
    product_attributes: [],
};

class MasterDataRequest extends Component {

    constructor(props) {
        super(props);
        this.state = {
            product: null,
            oldProduct: null,
            active: 1
        };
    }

    componentDidMount() {
        if (!this.props.hasPermission) {
            return this.props.redirectNoPermission();
        }
    }

    render() {
        return <div>

            <StepList active={this.state.active}/>


            <Container fluid>


                <Segment attached padded>

                    {this.state.active === 1 &&
                    <Search onProductSelect={(product) => {
                        this.onCompletionStep1(product);
                    }}/>
                    }

                    {this.state.active === 2 &&
                    <div>
                        <BasicInfos product={this.state.product} onComplete={(product) => {
                            this.onCompletionStep2(product);
                        }}/>
                    </div>
                    }

                    {this.state.active === 3 &&
                    <div>
                        <Attributes product={this.state.product} onComplete={(product) => {
                            this.onCompletionStep3(product);
                        }}/>
                    </div>
                    }

                    {this.state.active === 4 &&
                    <div>
                        <Prices product={this.state.product} onComplete={(product) => {
                            this.onCompletionStep4(product);
                        }}/>
                    </div>
                    }


                    {this.state.active === 5 &&
                    <div>
                        <Confirmation oldProduct={this.state.oldProduct}
                                      product={this.state.product} onComplete={(product) => {
                            this.onCompletionStep5(product);
                        }}/>
                    </div>
                    }

                </Segment>
            </Container>
        </div>;
    }

    fillEmptyProductFields(product) {

        for (let key in emptyProduct) {
            if (!product[key]) {
                product[key] = emptyProduct[key];
            }
        }

        return product;
    }

    onCompletionStep1(product) {


        product = this.fillEmptyProductFields(product);

        if (product.requestType !== 'newQuoteProduct' && product.price_lists.filter((pl) => (Number.parseInt(pl.pricelistID, 10) === 2)).length === 0) {
            product.price_lists.push(
                {
                    name: "Gastropreise",
                    pricelistID: 2,
                    pivot: {
                        price: 0
                    },
                    id: 5
                }
            );
        }

        return this.setState({
            product: { ...product },
            oldProduct: { ...JSON.parse(JSON.stringify(product)) },
            active: 2
        });
    }

    onCompletionStep2(product) {
        if(product.requestType === 'newQuoteProduct'){
            return this.setState({
                product: { ...product },
                active: 4
            });
        }
        this.setState({
            product: { ...product },
            active: 3
        });
    }

    onCompletionStep3(product) {
        this.setState({
            product: { ...product },
            active: 4
        });
    }

    onCompletionStep4(product) {
        this.setState({
            product: { ...product },
            active: 5
        });
    }

    onCompletionStep5() {
        this.setState({
            product: null,
            active: 1
        });

        this.props.resetSearch();
    }

}


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    products: getProducts(state.tools),
    hasPermission: hasPermission(state, "masterDataRequests")
});


const mapDispatchToProps = (dispatch) => {
    return ({
        findProducts: (code) => (dispatch(findProducts(code))),
        resetSearch: () => {
            dispatch({ type: RESET_SEARCH });
        },
        redirectNoPermission: () => (dispatch(push("/")))

    });
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MasterDataRequest);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/index.js